import {
	Divider,
	MenuList,
	MenuItem,
	Tooltip,
	Button,
	ToggleButtonGroup,
	ToggleButton, IconButton, Snackbar,
	ThemeProvider, Popper, ClickAwayListener, Typography
} from "@mui/material"
  import { useState, useEffect } from "react"
  import "./styles.scss"
  import toggleTheme from "../../../../components/toggleTheme"
  import { CheckRounded } from "@mui/icons-material"
import PropTypes from "prop-types";
import TextField from "@mui/material/TextField";
import CheckIcon from "@mui/icons-material/Check";

ValueMenu.propTypes = {
	type: PropTypes.string,
	grade: PropTypes.number,
	gradeType: PropTypes.string,
	valueId: PropTypes.number,
	studentId: PropTypes.number,
	student: PropTypes.object,
	key: PropTypes.number,
	content: PropTypes.element,
	changeHandler: PropTypes.func,
	removeHandler: PropTypes.func,
	disabled: PropTypes.bool,
	disciplineRequirements: PropTypes.array,
	grsParams: PropTypes.object
}
  
  export default function ValueMenu(props) {
	const [anchorEl, setAnchorEl] = useState(null)
	const [grade, setGrade] = useState(5);
    const [gradeType, setGradeType] = useState(null)
	const [open, setOpen] = useState(false)
	const [type, setType] = useState(null)
	const [snackbarOpen, setSnackbarOpen] = useState(false)
	const [snackbarMessage, setSnackbarMessage] = useState("")
  
	useEffect(() => {
		setType(props.type || null)
		
		if (props.grade > 0) {
		  	setGrade(props.grade)
		} else {
		  	setGrade(5)
		}
		
		if (gradeType === null || gradeType === undefined)
			setGradeType(props.gradeType);
		
		if (props?.disciplineRequirements?.length) {
			setValueTypes(props?.disciplineRequirements?.map((item) => {
				return {
					id: item.disciplineRequirementId,
					title: item.gradeTypeTitle,
					subtitle: controlTypeName(item.controlType),
					isPointsGradeType: item.conversionGrade2 === 0 && item.conversionGrade3 === 0 
						&& item.conversionGrade4 === 0 && item.conversionGrade5 === 0,
					points: item.points,
					gradeId: item.points,
					maxPoints: item.maxPoints
				}
			}) ?? []);
		} else {
			setValueTypes(getDefaultGradeTypes());
		}
		
	}, [props.type, props.gradeType, props.grade, props.disciplineRequirements])
	  
  	function getDefaultGradeTypes() {
		return [
			{ id: -1, title: "Тестирование" },
			{ id: -2, title: "Лабораторная работа" },
			{ id: -3, title: "Контрольная работа" },
			{ id: -4, title: "Расчётно-графическая работа" },
			{ id: -5, title: "Домашняя работа" },
			{ id: -6, title: "Другое" }
		];
	}
  
	// useEffect(() => {}, [anchorEl])
  
	const [valueTypes, setValueTypes] = useState([]);
		// [
		// 	{ id: 1, title: "Тестирование" },
		// 	{ id: 2, title: "Лабораторная работа" },
		// 	{ id: 3, title: "Контрольная работа" },
		// 	{ id: 4, title: "Расчётно-графическая работа" },
		// 	{ id: 5, title: "Домашняя работа" },
		// 	{ id: 6, title: "Другое" }
		// ]
  
	// Сохранение оценки
	const handleSubmit = () => {
	  if (!gradeType || !grade) {
		setSnackbarMessage("Выберите оценку и тип оценки")
		setSnackbarOpen(true)
  
		// Закрываем toast через 2 секунды
		setTimeout(() => {
		  setSnackbarOpen(false)
		}, 2000)
		return
	  }
	  
	  const sumOfPoints = sumPointsByDisciplineRequirementAndStudent(gradeType, props.student);
	  const valueType = valueTypes.find((item) => item.id === gradeType);
	  const maxPoints = valueType?.maxPoints;
	  const percentage = percentageByGradeId(grade);
	  const points = valueType?.points?.toFixed(3) * percentage;

	  if (sumOfPoints + points > maxPoints && valueType?.disciplineRequirementId > 0) {
		setSnackbarMessage(`Превышен лимит баллов по типу оценки для студента. Проверьте корректность данных`)
		setSnackbarOpen(true)
  
		// Закрываем toast через 2 секунды
		setTimeout(() => {
		  setSnackbarOpen(false)
		}, 2000);
		
		return;
	  }

	  setAnchorEl(null)
	  setOpen(false)
	  props.changeHandler(
		0,
		props.studentId,
		props.valueId,
		grade,
		gradeType,
	    valueType
	  )
	}
	
	function controlTypeName(type) {
		switch (type) {
			case 0:
				return "Аудиторная контактная работа обучающегося";
			case 1:
				return "Контроль самостоятельной работы обучающегося";
			default: return "";
		}
	}
  
	// Открытие popup
	const handleClick = e => {
		if (props.disabled){
			alert("Редактирование оценки запрещено");
			return;
		}
			
	  setAnchorEl(e.currentTarget)
	  setTimeout(() => setOpen(prev => !prev))
	}
  
	const handleGradeTypeChange = (id) => {
	  setGradeType(id)
	}
  
	const removeHandler = () => {
	  props.removeHandler?.(0, props.studentId, props.valueId)
	  setOpen(false)
	}
  
	const handleClickAway = e => {
	  setOpen(false)
	}

	  function numbersOnly(input) {
		  if (!input)
			  return '';

		  const allowedSymbols = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', ',', '.'];
		  let result = '';
		  input.split('').forEach((symbol, index) => {
			  if (allowedSymbols.includes(symbol)) {
				  result += symbol;
				  // if (symbol === ',' || symbol === '.' && input.length === index + 1) {
				  //     result += '0';
				  // }
			  }
		  });

		  result = result.replace(',', '.');

		  return result;
	  }
	  
	  function percentageByGradeId(gradeId) {
		  switch (parseFloat(gradeId.toString())) {
			  case 2: return props.grsParams.grade2Multiplier;
			  case 3: return props.grsParams.grade3Multiplier;
			  case 4: return props.grsParams.grade4Multiplier;
			  case 5: return props.grsParams.grade5Multiplier;
			  default: return 0;
		  }
	  }

	  function sumPointsByDisciplineRequirementAndStudent(disciplineRequirementId, student) {
		  if (!student || !disciplineRequirementId)
			  return 0;

		  let sum = 0;
		  student.pointsByDisciplineRequirements.forEach((item) => {
			  if (item.disciplineRequirementId === disciplineRequirementId) {
				  sum += item.pointsPerActivity * percentageByGradeId(item.gradeId);
			  }
		  });

		  return sum;
	  }
  
	const handleValue = (e, maxPoints) => {
		const newVal = numbersOnly(e.target.value);
		const comparableValue = parseFloat(newVal.endsWith('.') ? `${newVal}0` : newVal);
		if (comparableValue > maxPoints)
			return;
		
	  if (newVal !== null) {
		  setGrade(newVal)
	  }
	}
  
	const Header = () => {
	  switch (props.type) {
		case `update`:
		  return <div className="menu-header">Изменить оценку</div>
		default:
		  return <div className="menu-header">Новая оценка</div>
	  }
	}
  
	const menuitem = (element, index) => {
	  const icon =
		gradeType === element.id ? (
		  <CheckRounded sx={{ marginRight: "10px", padding: '10px 0px 0px 0px' }} />
		) : (
		  <CheckRounded
			key={index}
			sx={{ color: "transparent", marginRight: "10px" }}
		  />
		)
	  return (
		<MenuItem key={index} onClick={() => handleGradeTypeChange(element.id)}>
		  <Typography alignItems={'center'}>{icon} {element.title}</Typography>
		</MenuItem>
	  )
	}
  
	const tooltip = props.type === `create` ? "Добавить оценку" : valueTypes.find((item) => item.id === props.gradeType)?.title ?? ''
  
	let control = <></>
	if (props.grade) {
	  switch (props.grade) {
		case 5:
		  control = (
			<IconButton
			  color="success"
			  onClick={handleClick}
			  className="icon-button"
			>
			  {props.content}
			</IconButton>
		  )
		  break
		case 4:
		  control = (
			<IconButton
			  color="success"
			  onClick={handleClick}
			  className="icon-button"
			>
			  {props.content}
			</IconButton>
		  )
		  break
		case 3:
		  control = (
			<IconButton
			  color="warning"
			  onClick={handleClick}
			  className="icon-button"
			>
			  {props.content}
			</IconButton>
		  )
		  break
		case 2:
		  control = (
			<IconButton
			  color="error"
			  onClick={handleClick}
			  className="icon-button"
			>
			  {props.content}
			</IconButton>
		  )
		  break
		default:
		  control = (
			<IconButton onClick={handleClick} className="icon-button">
			  {props.content}
			</IconButton>
		  )
		  break
	  }
	}
	
	function getGradeInput() {
		const disciplineRequirement = valueTypes.find((item) => item.id === gradeType);
		const maxPoints = disciplineRequirement?.maxPoints ?? 0;
		return disciplineRequirement?.isPointsGradeType
		? <>
			<TextField size={'small'}
					   value={grade > maxPoints ? 0 : grade}
					   type={'number'}
					   onChange={(event) => handleValue(event, maxPoints)}
					   label={`Баллы (${maxPoints} макс.)`} />
			</>
		: <>
			<ToggleButtonGroup
				exclusive
				value={parseFloat(grade)}
				onChange={(event) => handleValue(event, 5)}
			>
				<ToggleButton size="small" value={5}>
					5
				</ToggleButton>
				<ToggleButton size="small" value={4}>
					4
				</ToggleButton>
				<ToggleButton size="small" value={3}>
					3
				</ToggleButton>
				<ToggleButton size="small" value={2}>
					Неуд
				</ToggleButton>
			</ToggleButtonGroup>
		</>
	}
  
	return (
	  <>
		<Tooltip title={tooltip} placement="top">
		  {control}
		</Tooltip>
		<ClickAwayListener onClickAway={handleClickAway}>
		  <Popper
			id="placement-popper"
			open={open}
			anchorEl={anchorEl}
			placement="bottom-end"
		  >
			<div className="popup-menu-wrapper">
			  <Header />
			  <Divider />
			  <div className="value">
				<ThemeProvider theme={toggleTheme}>
					{getGradeInput()}
				</ThemeProvider>
			  </div>
			  <div className="types">
				<MenuList>
				  {valueTypes.map((el, index) => {
					return menuitem(el, index)
				  })}
				</MenuList>
			  </div>
			  <Divider />
			  <div className="actions">
				{props.type === `update` ? (
				  <Button
					onClick={removeHandler}
					variant="text"
					sx={{ color: "red" }}
				  >
					Удалить
				  </Button>
				) : (
				  <span>{' '}</span>
				)}
				<Button onClick={handleSubmit}>Ок</Button>
			  </div>
			</div>
		  </Popper>
		</ClickAwayListener>
		<Snackbar
		  open={snackbarOpen}
		  message={snackbarMessage}
		  anchorOrigin={{
			vertical: "bottom",
			horizontal: "right"
		  }}
		/>
	  </>
	)
  }
  